import axios from 'axios';
import { ITax, ITaxCreate, ITaxUpdate } from '../types/tax';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const taxService = {
  // Get all taxes
  getAllTaxes: async (): Promise<ITax[]> => {
    try {
      const response = await axios.get(`${API_URL}/taxes`);
      return response.data.data.taxes;
    } catch (error) {
      console.error('Error fetching taxes:', error);
      throw error;
    }
  },

  // Get a single tax by ID
  getTaxById: async (id: string): Promise<ITax> => {
    try {
      const response = await axios.get(`${API_URL}/taxes/${id}`);
      return response.data.data.tax;
    } catch (error) {
      console.error(`Error fetching tax with id ${id}:`, error);
      throw error;
    }
  },

  // Create a new tax
  createTax: async (taxData: ITaxCreate): Promise<ITax> => {
    try {
      const response = await axios.post(`${API_URL}/taxes`, taxData);
      return response.data.data.tax;
    } catch (error) {
      console.error('Error creating tax:', error);
      throw error;
    }
  },

  // Update an existing tax
  updateTax: async (id: string, taxData: ITaxUpdate): Promise<ITax> => {
    try {
      const response = await axios.patch(`${API_URL}/taxes/${id}`, taxData);
      return response.data.data.tax;
    } catch (error) {
      console.error(`Error updating tax with id ${id}:`, error);
      throw error;
    }
  },

  // Delete a tax
  deleteTax: async (id: string): Promise<void> => {
    try {
      await axios.delete(`${API_URL}/taxes/${id}`);
    } catch (error) {
      console.error(`Error deleting tax with id ${id}:`, error);
      throw error;
    }
  },

  // Toggle tax active status
  toggleTaxStatus: async (id: string): Promise<ITax> => {
    try {
      const response = await axios.patch(`${API_URL}/taxes/${id}/toggle-status`);
      return response.data.data.tax;
    } catch (error) {
      console.error(`Error toggling status for tax with id ${id}:`, error);
      throw error;
    }
  }
};

export default taxService;